
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { CountryResponse } from "../../models/dtos";

export const countriesApi = createApi({
  reducerPath: 'countriesApi',
  baseQuery: baseAuthQuery('Countries'),
  tagTypes: ['Country'],
  endpoints: (builder) => ({
    getCountries: builder.query<ApiResponse<CountryResponse[]>, void>({
      query: () => "",
      providesTags: ['Country'],
    }),
    getCountryById: builder.query<ApiResponse<CountryResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Country'],
    }),
    updateCountry: builder.mutation<ApiResponse<CountryResponse>, Partial<CountryResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Country'],
    }),
    deleteCountry: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Country'],
    }),
  }),
});
